import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserGraduate, FaEdit, FaFacebook, FaYoutube, FaTwitter, FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
import AccountSetup from "../AccountSetup/AccountSetup";
import ConnectedRoute from "../ConnectedRoute";
import JavaScript from "../../media/photos/program-badges/javascript-badge.png";
import ReactJS from "../../media/photos/program-badges/react-badge.png";
// import Form from "../Form"
// https://www.youtube.com/watch?v=vVDD3O_p5Q4

const editor = () => {
  return <ConnectedRoute component={AccountSetup} />
}

export default function Profile() {
  return (
    <div className="container">
      <div className="row d-flex justify-content-center">
        <div className="col-md-12 mt-5 pt-5">
          <div className="row z-depth-3">
            <div className="col-sm-4 bg-primary rounded-left">
              <div className="card-block text-center text-white">
                <div className="mt-5">
                  <FaUserGraduate size="7em" color="#E7C438" />
                </div>
                <h2 className="font-weight-bold mt-4">Kenzie Student</h2>
                <p>Software Engineering Student</p>
                <FaEdit onClick={editor} />
              </div>
            </div>
            <div className="col-sm-8 bg-white rounded-right">
              <h3 className="mt-3 text-center">Information</h3>
              <hr className="badge-primary"></hr>
              <div className="row">
                <div className="col-sm-6">
                  <p className="font-weight-bold">Email:</p>
                  <h6 className="text-muted">KenzieLearn@gmail.com</h6>
                </div>
                <div className="col-sm-6">
                  <p className="font-weight-bold">Phone:</p>
                  <h6 className="text-muted">+1-111-111-1111</h6>
                </div>
              </div>
              <h4 className="mt-3">Badges</h4>
              <hr className="bg-primary"></hr>
              <div className="row">
                <div className="col-sm-6">
                  <p className="font-weight-bold">Recent:</p>
                  <img src={ReactJS} alt="ReactJS Badge" width="100px" />
                </div>
                <div className="col-sm-6">
                  <p className="font-weight-bold">Most viewed:</p>
                  <img src={JavaScript} alt="JavaScript Badge" width="100px" />
                </div>
              </div>
              <hr className="bg-primary"></hr>
              <ul className="list-unstyled d-flex justify-content-center mt-4">
                <li href="#">
                  <FaFacebook color="#E7C438" />
                </li>
                <li href="#">
                  <FaYoutube color="#E7C438" />
                </li>
                <li href="#">
                  <FaTwitter color="#E7C438" />
                </li>
                <li href="#">
                  <FaLinkedin color="#E7C438" />
                </li>
                <li href="#">
                  <FaInstagram color="#E7C438" />
                </li>
                <li href="#">
                  <FaGithub color="#E7C438" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
